export default __webpack_public_path__ + "static/media/faq_banner.bc326eb5.jpg";